var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"absolute right-4",on:{"click":function($event){_vm.isFullScreen = !_vm.isFullScreen}}},[_c('img',{attrs:{"src":!_vm.isFullScreen
        ? require('@/assets/table/open.svg')
        : require('@/assets/table/close.svg'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }